export default __webpack_public_path__ + "static/media/regulatory--one-way-left--g2.50ea813a.png";